import config from "../../config/config";
import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button, Modal } from "react-bootstrap";
import LookupReceiptModal from "./LookupReceiptModal";

let LocationItemData = [{}];
let allData = [];

function DescriptionModal({}) {
  // let LocationItemData = [];
  const token = localStorage.getItem("Token");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [descriptionChange, setDescriptionChange] = useState();

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <div
        class="modal fade"
        data-bs-backdrop="static"
        id="NewWorkModal"
        tabindex="-1"
        aria-labelledby="NewWorkModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="NewWorkModalLabel">
                Description
              </h1>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                // onClick={handleClose}
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body"></div>
            <div class="modal-footer fs-5 row">
              <div class="col " style={{ borderTop: "1px solid #e9ecef" }}>
                <button
                  type="button"
                  class="btn btn-secondary pull-right mt-2"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  // to="/editworkorder"
                  type="button"
                  class="btn btn-primary pull-right me-1 mt-2"
                  //   onClick={handleSubmit}
                >
                  {/* Save changes*/}
                  <Link class="dropdown-item" to="/editworkorder/:id">
                    Save Changes
                  </Link>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DescriptionModal;
